const myPagesBaseUrl = '/api/mypageservice/proxy';
export const ADD_FAVORITE_URL = myPagesBaseUrl + '/favorite/add'
export const DELETE_FAVORITE_URL = myPagesBaseUrl + '/favorite/delete'
export const GET_ALL_FAVORITES_URL = myPagesBaseUrl + '/favorite/getall'
